/*!

=========================================================
* BootstrapVue Argon Dashboard PRO - v1.0.0
=========================================================

* Product Page: https://www.creative-tim.com/product/bootstrap-vue-argon-dashboard-pro
* Copyright 2020 Creative Tim (https://www.creative-tim.com)

* Coded by www.creative-tim.com

=========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.

*/
import Vue from 'vue';
import DashboardPlugin from './plugins/dashboard-plugin';
import App from './App.vue';

//helpers
import helpers from './util/helpers.js'
window.helpers = helpers

//axios
import axios from 'axios'
window.axios = axios
import "vue-easytable/libs/theme-default/index.css"; // import style
import VueEasytable from "vue-easytable"; // import library

//import VueAxios from 'vue-axios'
//Vue.prototype.$http = axios
//Vue.use(VueAxios, axios)

//storage
//import StoragePlugin from 'vue-web-storage';  
//Vue.use(StoragePlugin, {})

// router setup
import router from './routes/fullstack_gui';

// plugin setup
Vue.use(DashboardPlugin);
Vue.use(VueEasytable);

let vm = new Vue({
  el: '#app',
  render: h => h(App),
  router
});

global.vm = vm
